module.exports = __webpack_public_path__ + "img/freddie dress 2.f66cf65e.png";